/* eslint-disable no-undef */
import $ from "jquery";
import mapplic from "mapplic";

export default class MallMap {
    constructor() {
        this.body = document.body;
        this.mapplic = document.getElementById("mapplic");

        this.events();
    }

    events() {
        this.initMapplic();
        this.displayShopOnMapBySelect();
    }

    initMapplic() {
        if (typeof mapplic === "object") {
            const mmap = $(this.mapplic).mapplic({
                source: __jsVarsMapp.mapplic,
                height: 600,
                sidebar: false,
                minimap: false,
                zoombuttons: true,
                deeplinking: false,
                fullscreen: true,
                maxscale: 4,
                zoom: true,
                skin: "mapplic-dark",
                developer: false,
                markers: false,
                mousewheel: false,
                clearbutton: true,
            });

            const self = mmap.data("mapplic");

            const mapplicPopupLink = document.querySelector(
                ".mapplic-popup-link"
            );

            if (mapplicPopupLink) mapplicPopupLink.innerText = "Więcej";

            self.switchLevel("level-0");

            if (window.location.hash.indexOf("location") !== -1) {
                const lok = window.location.hash.slice(
                    window.location.hash.indexOf("=") + 1
                );

                self.showLocation(lok, 500);

                const aHeading = this.body.querySelector(".a-heading");

                if (aHeading) {
                    const searchSectionPosition =
                        aHeading.getBoundingClientRect().top;

                    window.scrollBy({
                        top: searchSectionPosition - 30,
                        behavior: "smooth",
                    });
                }
            }

            /* if category is chosen add category color to corresponding shops on map */
            if (
                this.body.classList.contains("post-type-archive-ic-shop") &&
                this.body.classList.contains("with-category")
            ) {
                setTimeout(function () {
                    let currentCategoryColor;
                    const currentCategory = window.location.href
                        .split("/")
                        .slice(-2, -1)[0];

                    __jsVarsMapp.mapplic.categories.forEach(function (el) {
                        if (el.id === currentCategory)
                            currentCategoryColor = el.color;
                    });

                    const levels = __jsVarsMapp.mapplic.levels;
                    // eslint-disable-next-line no-unused-vars
                    const allLoca = levels.forEach(function (el) {
                        el.locations.forEach(function (el) {
                            if (el.category.indexOf(currentCategory) > -1) {
                                if (document.getElementById(el.id))
                                    document.getElementById(el.id).style.fill =
                                        currentCategoryColor;
                            }
                        });
                    });
                }, 500);
            }
        }
    }

    displayShopOnMapBySelect() {
        const self = this;

        /* Choose shop on map */
        $("body").on("change", ".js--choose-shop", function () {
            const localId = this.value;
            const mapplickElement = $(self.mapplic).data("mapplic");

            mapplickElement.showLocation(localId, 500);

            const selectedItems = [
                ...document.querySelectorAll(".selectric-items .selected"),
            ];

            if (selectedItems.length) {
                selectedItems.forEach((selectedItem) => {
                    const selectWrapper =
                        selectedItem.closest(".selectric-wrapper");

                    if (parseInt(selectedItem.dataset.index, 10) === 0) {
                        selectWrapper.classList.add("first-selected");
                        mapplickElement.hideLocation();
                        mapplickElement.moveTo(1, 1, 0, 500);
                    } else {
                        selectWrapper.classList.remove("first-selected");
                    }
                });
            }
        });
    }
}
